// components/DateRangePicker.jsx
import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";

export default function DateRangePicker({ range, onChange }) {
  const [isOpen, setIsOpen] = useState(false);

  const togglePicker = () => setIsOpen(!isOpen);

  const handleChange = (dates) => {
    const [start, end] = dates;
    onChange({ from: start, to: end });
  };

  const today = new Date();

  return (
    <div className="position-relative">
      <button
        className="btn btn-outline-secondary d-flex align-items-center" style={{ gap: "0.5rem" }}
        onClick={togglePicker}
      >
        <i className="bi bi-calendar3"></i>
        {range.from && range.to ? (
          <>
            {format(range.from, "dd/MM/yyyy")} → {format(range.to, "dd/MM/yyyy")}
          </>
        ) : (
          "Select date range"
        )}
      </button>

      {isOpen && (
        <div
          className="position-absolute bg-white border rounded p-2 mt-2 shadow"
          style={{ zIndex: 1000 }}
        >
          <DatePicker
            selectsRange
            startDate={range.from}
            endDate={range.to}
            onChange={handleChange}
            maxDate={today}
            inline
          />
          <div className="d-flex justify-content-end mt-2">
            <button
              className="btn btn-sm btn-secondary"
              onClick={() => setIsOpen(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
